import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/cms/ui/alert-dialog";
import LureoButton from '@/common/LureoButton';

interface StoriesLimitWarningDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  onCancel: () => void;
  storiesBeingFrozen: Array<{
    name: string;
  }>;
  maxStories: number;
  currentPlan: string;
}

export function StoriesLimitWarningDialog({
  open,
  onOpenChange,
  onConfirm,
  onCancel,
  storiesBeingFrozen,
  maxStories,
  currentPlan
}: StoriesLimitWarningDialogProps) {

  const handleConfirm = () => {
    onConfirm();
    onOpenChange(false);
  };

  const handleCancel = () => {
    onCancel();
    onOpenChange(false);
  };

  const frozenStoryNames = storiesBeingFrozen.map(s => s.name).join(', ');

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="cursor-default select-none">
        <AlertDialogHeader>
          <AlertDialogTitle>Story Limit Reached</AlertDialogTitle>
        </AlertDialogHeader>

        <AlertDialogBody>
          <AlertDialogDescription asChild>
            <div className="space-y-3">
              <p>
                Your <span className="font-semibold">{currentPlan}</span> plan allows {maxStories} editable {maxStories === 1 ? 'story' : 'stories'}.
              </p>

              <p>
                Creating a new story will make the following {storiesBeingFrozen.length === 1 ? 'story' : 'stories'} read-only:
              </p>

              <div className="rounded-lureo-radius-lg bg-lureo-danger border-lureo-border-width border-lureo-warning/50 p-3">
                <p className="font-medium text-lureo-on-emphasis">
                  {frozenStoryNames}
                </p>
              </div>

              <p className="text-lureo-14 text-lureo-ink-subtle leading-5">
                Read-only stories can still be viewed and published, but cannot be edited.
                Your most recently updated stories will remain editable.
              </p>
            </div>
          </AlertDialogDescription>
        </AlertDialogBody>

        <AlertDialogFooter>
          <LureoButton
            variant="outline-2"
            suppressTooltip
            className="h-9 px-5 rounded-lureo-radius-button-pill"
            onClick={handleCancel}
          >
            Cancel
          </LureoButton>
          <LureoButton
            variant="secondary"
            suppressTooltip
            onClick={handleConfirm}
            className="h-9 px-4 rounded-lureo-radius-button-pill"
          >
            Create Story
          </LureoButton>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
